import React, { useEffect, useRef, useState } from 'react';

const StatBlock = ({ number, label }) => {
  const [count, setCount] = useState(0);
  const [hasAnimated, setHasAnimated] = useState(false);
  const ref = useRef(null);

  // Extract numeric value from string (e.g., "17+" -> 17)
  const targetValue = parseInt(number.replace(/[^0-9]/g, ''));
  const suffix = number.replace(/[0-9]/g, '');

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasAnimated) {
          setHasAnimated(true);
          
          const duration = 2000;
          const steps = 60;
          const stepValue = targetValue / steps;
          const stepDuration = duration / steps;
          
          let currentStep = 0;
          const timer = setInterval(() => {
            currentStep++;
            if (currentStep <= steps) {
              setCount(Math.floor(stepValue * currentStep));
            } else {
              setCount(targetValue);
              clearInterval(timer);
            }
          }, stepDuration);
          
          return () => clearInterval(timer);
        }
      },
      { threshold: 0.2 }
    );

    const currentRef = ref.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [targetValue, hasAnimated]);

  return (
    <div ref={ref} className="text-center group">
      <div className="text-5xl md:text-6xl lg:text-7xl font-extrabold text-white mb-3 tracking-tight">
        {hasAnimated ? count : 0}{suffix}
      </div>
      <div className="text-sm text-white/80 font-semibold uppercase tracking-[0.15em]">
        {label}
      </div>
    </div>
  );
};

export default StatBlock;